import axiosMeth from "@/axiosMeth";

export default {
  // دریافت لیست شبکه‌های اجتماعی
  getSocialNetworks() {
    return axiosMeth.requestApiGet("social/");
  },

  // ثبت/به‌روزرسانی داده‌های شبکه اجتماعی
  saveSocialData(socialId, packId, data) {
    return axiosMeth.requestApiPost("social/data", {
      social_id: socialId,
      pack_id: packId,
      data: data,
    });
  },
  saveSocialDataBale(socialId, userId, status, data, expire_at, max_sends) {
    return axiosMeth.requestApiPost("admin/social/data", {
      social_id: socialId,
      status: status,
      expire_at: expire_at,
      max_sends: max_sends,
      user_id: userId,
      data: data,
    });
  },

  // ارسال پیام
  sendSocialMessage(data) {
    return axiosMeth.requestApiPost("social/send", data);
  },

  // دریافت پک‌های شبکه اجتماعی
  getSocialPacks(socialId) {
    return axiosMeth.requestApiGet(`social/packs/${socialId}`);
  },

  // خرید پک
  buySocialPack(socialPackId) {
    return axiosMeth.requestApiGet(`social/packs/buy/${socialPackId}`);
  },
  getsocialUser(param) {
    return axiosMeth.requestApiGet(`social/data`, param);
  },
  getsocialAdmin(param) {
    return axiosMeth.requestApiGet(`admin/social/data`, param);
  },
  registerPhone() {
    return axiosMeth.requestApiGet("social/register/whats-app");
  },
  getWhatsappAdmin() {
    return axiosMeth.requestApiGet("admin/social");
  },
};
